import React from 'react'
import { inject, observer } from 'mobx-react'
import { LayerGroup } from 'react-leaflet'
import classnames from 'classnames'
import DynamicGeoJSON from './DynamicGeoJSON'
import { smoothFactor } from 'utils'
import { defaultPolygonColor } from '../../constants'

/**
 * Renders the draft polygon from poi.draftPolygon when in draft mode.
 * This allows the polygon to stay visible even after the selection is cleared.
 * Uses the same rendering approach as saved Geopolygons for consistency.
 */
const DraftPolygonLayer = ({ dataStore, uiStore, selectionStore }) => {
  const poi = dataStore && dataStore.poi
  const draftPolygon = poi && poi.draftPolygon

  // Only render if in draft mode and there's a draft polygon
  if (!poi || !poi.isDraftMode || !draftPolygon || !draftPolygon.geometry) {
    return null
  }

  // Resolve color_id to actual color (same as Geopolygon.getColor)
  const colorItem = dataStore.markerColors.find(item => item.id === draftPolygon.color_id)
  const resolvedColor = colorItem ? colorItem.active_color : defaultPolygonColor

  // Calculate smooth factor for better rendering (same as Geopolygon)
  const polygonSmoothFactor = smoothFactor(draftPolygon.geometry)

  return (
    <LayerGroup>
      <DynamicGeoJSON
        key={`draft-polygon-${Date.now()}`}
        data={draftPolygon.geometry}
        color={resolvedColor}
        stroke={false}
        smoothFactor={polygonSmoothFactor}
        className={classnames({
          'with-overlay': uiStore.densityLayer !== 'none',
          geopolygon: true,
          'geopolygon--draft': true
        })}
        fillOpacity={`${draftPolygon.transparency || 50}%`}
      />
    </LayerGroup>
  )
}

export default inject('dataStore', 'uiStore', 'selectionStore')(observer(DraftPolygonLayer))
